import { render, staticRenderFns } from "./TaskIssueLiuLan.vue?vue&type=template&id=fd0b2f6e&"
import script from "./TaskIssueLiuLan.vue?vue&type=script&lang=js&"
export * from "./TaskIssueLiuLan.vue?vue&type=script&lang=js&"
import style0 from "./TaskIssueLiuLan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports